var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "height": "200px",
      "width": "200px",
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "viewBox": "0 0 512 512",
      "xml:space": "preserve",
      "fill": "#000000"
    }
  }, [_c('g', {
    attrs: {
      "id": "SVGRepo_bgCarrier",
      "stroke-width": "0"
    }
  }), _c('g', {
    attrs: {
      "id": "SVGRepo_tracerCarrier",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('g', {
    attrs: {
      "id": "SVGRepo_iconCarrier"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(0 1)"
    }
  }, [_c('polygon', {
    staticStyle: {
      "fill": "#00da6c"
    },
    attrs: {
      "points": "34.133,498.2 477.867,498.2 477.867,11.8 34.133,11.8 "
    }
  }), _c('polygon', {
    staticStyle: {
      "fill": "#00ad55"
    },
    attrs: {
      "points": "477.867,498.2 503.467,498.2 503.467,11.8 477.867,11.8 "
    }
  }), _c('polygon', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "points": "8.533,498.2 34.133,498.2 34.133,11.8 8.533,11.8 "
    }
  }), _c('path', {
    attrs: {
      "d": "M512,506.733H0v-384c0-5.12,3.413-8.533,8.533-8.533s8.533,3.413,8.533,8.533v366.933h477.867v-76.8 c0-5.12,3.413-8.533,8.533-8.533c5.12,0,8.533,3.413,8.533,8.533V506.733z"
    }
  }), _c('path', {
    attrs: {
      "d": "M503.467,344.6c-5.12,0-8.533-3.413-8.533-8.533V20.333H17.067v34.133c0,5.12-3.413,8.533-8.533,8.533S0,59.587,0,54.467 v-51.2h512v332.8C512,341.187,508.587,344.6,503.467,344.6z"
    }
  }), _c('path', {
    attrs: {
      "d": "M17.067,88.6c0-5.12-3.413-8.533-8.533-8.533S0,83.48,0,88.6s3.413,8.533,8.533,8.533S17.067,93.72,17.067,88.6"
    }
  }), _c('path', {
    attrs: {
      "d": "M503.467,387.267c-5.12,0-8.533-3.413-8.533-8.533V370.2c0-5.12,3.413-8.533,8.533-8.533c5.12,0,8.533,3.413,8.533,8.533 v8.533C512,383.853,508.587,387.267,503.467,387.267z"
    }
  }), _c('path', {
    attrs: {
      "d": "M409.6,122.733H221.867c-5.12,0-8.533-3.413-8.533-8.533s3.413-8.533,8.533-8.533H409.6c5.12,0,8.533,3.413,8.533,8.533 S414.72,122.733,409.6,122.733z"
    }
  }), _c('path', {
    attrs: {
      "d": "M409.6,259.267H221.867c-5.12,0-8.533-3.413-8.533-8.533c0-5.12,3.413-8.533,8.533-8.533H409.6 c5.12,0,8.533,3.413,8.533,8.533C418.133,255.853,414.72,259.267,409.6,259.267z"
    }
  }), _c('path', {
    attrs: {
      "d": "M409.6,395.8H221.867c-5.12,0-8.533-3.413-8.533-8.533s3.413-8.533,8.533-8.533H409.6c5.12,0,8.533,3.413,8.533,8.533 S414.72,395.8,409.6,395.8z"
    }
  }), _c('path', {
    attrs: {
      "d": "M136.533,122.733c-5.12,0-8.533-3.413-8.533-8.533V71.533c0-5.12,3.413-8.533,8.533-8.533s8.533,3.413,8.533,8.533V114.2 C145.067,119.32,141.653,122.733,136.533,122.733z"
    }
  }), _c('path', {
    attrs: {
      "d": "M136.533,165.4c-5.12,0-8.533-3.413-8.533-8.533V114.2c0-5.12,3.413-8.533,8.533-8.533s8.533,3.413,8.533,8.533v42.667 C145.067,161.987,141.653,165.4,136.533,165.4z"
    }
  }), _c('path', {
    attrs: {
      "d": "M102.4,114.2c-2.56,0-4.267-0.853-5.973-2.56c-3.413-3.413-3.413-8.533,0-11.947L130.56,65.56 c3.413-3.413,8.533-3.413,11.947,0c3.413,3.413,3.413,8.533,0,11.947l-34.133,34.133C106.667,113.347,104.96,114.2,102.4,114.2z"
    }
  }), _c('path', {
    attrs: {
      "d": "M153.6,301.933h-42.667c-4.267,0-7.68-2.56-9.387-5.973c-1.707-3.413-0.853-7.68,1.707-11.093l38.4-45.227 c4.267-5.12,4.267-11.093,1.707-15.36c-0.853-2.56-4.267-7.68-11.093-7.68c-9.387,0-17.067,7.68-17.067,17.067 c0,5.12-3.413,8.533-8.533,8.533s-8.533-3.413-8.533-8.533c0-18.773,15.36-34.133,34.133-34.133 c11.947,0,22.187,6.827,27.307,17.92c5.12,11.093,3.413,23.893-4.267,33.28l-29.013,34.133H153.6c5.12,0,8.533,3.413,8.533,8.533 C162.133,298.52,158.72,301.933,153.6,301.933z"
    }
  }), _c('path', {
    attrs: {
      "d": "M128,395.8h-17.067c-5.12,0-8.533-3.413-8.533-8.533s3.413-8.533,8.533-8.533H128c5.12,0,8.533,3.413,8.533,8.533 S133.12,395.8,128,395.8z"
    }
  }), _c('path', {
    attrs: {
      "d": "M128,438.467h-17.067c-5.12,0-8.533-3.413-8.533-8.533s3.413-8.533,8.533-8.533H128c6.827,0,12.8-5.973,12.8-12.8 c0-6.827-5.973-12.8-12.8-12.8v-17.067c6.827,0,12.8-5.973,12.8-12.8s-5.973-12.8-12.8-12.8h-17.067 c-5.12,0-8.533-3.413-8.533-8.533c0-5.12,3.413-8.533,8.533-8.533H128c16.213,0,29.867,13.653,29.867,29.867 c0,8.533-3.413,16.213-9.387,21.333c5.12,5.12,9.387,12.8,9.387,21.333C157.867,424.813,144.213,438.467,128,438.467z"
    }
  })])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }